// Click-to-play video covers (Views/Partials/VideoCover.cshtml).
// The embed waits in a <template> so nothing loads from the video host until the
// visitor presses play; the cover is then swapped for the embed.
export function initVideoCovers() {
    document.querySelectorAll<HTMLElement>('[data-video-cover]').forEach(cover => {
        const button = cover.querySelector<HTMLButtonElement>('[data-video-cover-play]');
        const template = cover.querySelector<HTMLTemplateElement>('template[data-video-cover-embed]');
        if (!button || !template) {
            return;
        }

        button.addEventListener('click', () => {
            cover.replaceChildren(template.content.cloneNode(true));
            cover.classList.add('is-playing');
            cover.querySelector<HTMLIFrameElement>('iframe')?.focus();
        });
    });
}
